import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AzureTenant } from '../../models/azureTenant';
import { DataService } from '@shared/services/data/data.service';
import { Bind } from 'primeng/bind';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
  selector: 'app-tenant-selection',
  templateUrl: './tenant-selection.component.html',
  styleUrls: ['./tenant-selection.component.scss'],
  imports: [Bind, ProgressSpinner],
})
export class TenantSelectionComponent {
  @Input() connectedTenants: AzureTenant[] = [];
  @Input() selectedTenantId: string | undefined;
  @Input() isLoading = false;
  @Output() tenantSelected = new EventEmitter<string>();

  constructor(public readonly dataService: DataService) {}

  selectTenant(id: string) {
    this.tenantSelected.emit(id);
  }
}
